import { getApi } from 'common/modules/ReactShared/data/api/apiClient';
import {
  IAnswerCheck,
  IAttemptAnswer,
  IClassQuiz,
  ILiveGame,
  ILiveGameResponse,
  IReplayQuizzesPage
} from './types';

/** The class game the student can join now, or null. Home asks when it opens and comes to the front. */
export async function getLiveGame(): Promise<ILiveGame | null> {
  const { data } = await getApi().get<ILiveGameResponse>('/quizzes/live');
  return data.live;
}

export async function getReplayQuizzes(page = 1): Promise<IReplayQuizzesPage> {
  const { data } = await getApi().get<IReplayQuizzesPage>('/quizzes', {
    params: { page }
  });
  return data;
}

export async function getClassQuiz(id: string): Promise<IClassQuiz> {
  const { data } = await getApi().get<IClassQuiz>(quizPath(id));
  return data;
}

const quizPath = (quizId: string): string => `/quizzes/${encodeURIComponent(quizId)}`;

/** Starts a self-study run under an id the app made; the same id starts it once. */
export async function startAttempt(quizId: string, id: string): Promise<void> {
  await getApi().post(`${quizPath(quizId)}/attempts`, { attempt: { id } });
}

/** The server checks one answer of a run; a repeat gets the answer it kept the first time. */
export async function submitAnswer(
  quizId: string,
  attemptId: string,
  answer: IAttemptAnswer
): Promise<IAnswerCheck> {
  const { data } = await getApi().post<IAnswerCheck>(
    `${quizPath(quizId)}/attempts/${encodeURIComponent(attemptId)}/answers`,
    { answer }
  );
  return data;
}
